import { render, staticRenderFns } from "./bandwidth.vue?vue&type=template&id=d95206b0"
import script from "./bandwidth.vue?vue&type=script&lang=js"
export * from "./bandwidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports